/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { translate } from '@utils/i18n';
import TooltipText from '@components/v2/TooltipText';
const STATUS_CONFIG = {
    pending: {
        label: translate('status.pending', { namespace: 'features.iim_review.submissions_timeline' }),
        className: 'status-pending',
        icon: 'fa-light fa-clock'
    },
    in_progress: {
        label: translate('status.in_progress', { namespace: 'features.iim_review.submissions_timeline' }),
        className: 'status-in-progress',
        icon: 'fa-light fa-clock'
    },
    completed: {
        label: translate('status.completed', { namespace: 'features.iim_review.submissions_timeline' }),
        className: 'status-completed',
        icon: 'fa-light fa-check'
    },
    failed: {
        label: translate('status.failed', { namespace: 'features.iim_review.submissions_timeline' }),
        className: 'status-failed',
        icon: 'fa-light fa-xmark'
    }
};
export default function StatusIndicator({ status }) {
    const config = STATUS_CONFIG[status];
    return (React.createElement(TooltipText, { text: config.label },
        React.createElement("span", { className: config.className },
            React.createElement("i", { className: config.icon }))));
}
